<div *ngFor="let q of questions; let qi = index" class="form-group mt-3">
    <label class="mb-2 font-weight-bold">{{ q.label }} <span *ngIf="q.required" class="text-danger" title="Required">*</span></label>
    <small *ngIf="q.type === 'MULTI_SELECT'" class="d-block text-muted mb-1">Select all that apply</small>
    <div *ngFor="let opt of q.options; let oi = index" class="form-check" [class.mt-1]="oi > 0">
        <ng-container *ngIf="q.type === 'MULTI_SELECT'; else radioOption">
            <input type="checkbox"
                   [id]="idPrefix + '_' + qi + '_' + oi"
                   [checked]="isSelected(q, opt.optionId!)"
                   (change)="toggle(q, opt.optionId!)">
            <label class="checkbox mb-0" [for]="idPrefix + '_' + qi + '_' + oi">{{ opt.label }}</label>
        </ng-container>
        <ng-template #radioOption>
            <input type="radio"
                   [id]="idPrefix + '_' + qi + '_' + oi"
                   [name]="idPrefix + '_' + qi"
                   [checked]="isSelected(q, opt.optionId!)"
                   (change)="toggle(q, opt.optionId!)">
            <label class="radio mb-0" [for]="idPrefix + '_' + qi + '_' + oi">{{ opt.label }}</label>
        </ng-template>
    </div>
    <small class="text-danger d-block mt-1" *ngIf="hasError(q)">
        <i class="uil uil-exclamation-circle mr-1"></i>
        Please {{ q.type === 'MULTI_SELECT' ? 'select at least one option' : 'select an option' }}.
    </small>
</div>
